import { render, staticRenderFns } from "./digitalMenuComponent.vue?vue&type=template&id=6b106106&scoped=true"
import script from "./digitalMenuComponent.vue?vue&type=script&lang=js"
export * from "./digitalMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b106106",
  null
  
)

export default component.exports